'use strict';

const Mn = require('backbone.marionette');
const NavView = require('balus/ui/view/body/role-dashboard/nav/index');
const ContentView = require('balus/ui/view/body/project-role/content/index');
const TitleView = require('balus/ui/view/body/project-role/title');
const CoverView = require('balus/ui/view/body/group/cover');
const Template = require('balus/ui/template/body/project-role/index.hbs');

module.exports = Mn.View.extend({
    className: 'row',
    template: Template,
    regions: {
        cover: '#cover',
        title: '#title',
        nav: '#nav',
        toolbar: '#toolbar',
        content: '#content',
    },

    onRender: function() {
        const group = this.getOption('group');

        this.showChildView('cover', new CoverView({
            model: group,
            roles: true
        }));
        this.showChildView('nav', new NavView({
            model: group,
            groupRole: this.model,
            user: this.getOption('user')
        }));
        this.showChildView('title', new TitleView({
            model: this.model
        }));
        this.showChildView('content', new ContentView({
            model: this.model
        }));
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/project-role/index.js